import React, { useContext } from "react"
import {
  Main,
  Wrapper,
  OpinionsComponent,
  PersonBox,
  SingleOpinion,
  SingleSide,
} from "./style"
import mariuszImage from "../../../images/mariusz.png"
import patrycjaImage from "../../../images/patrycja.png"
import danielImage from "../../../images/daniel.png"
import beataImage from "../../../images/beata.png"
import emiliaImage from "../../../images/emilia.png"
import lion from "../../../images/lion2.png"
import { ResolutionContext } from "../../../contexts/ResolutionContext"

const ThirdSection = ({
  happy_clients,
  client1,
  client2,
  client3,
  client4,
  client5,
  client1_text,
  client2_text,
  client3_text,
  client4_text,
  client5_text,
}) => {
  const [isTablet, isTabletAndPhone, isPhone] = useContext(ResolutionContext)

  if (isTablet) {
    return (
      <Main>
        <img src={lion} alt="lew" />
        <Wrapper>
          <h3>{happy_clients}</h3>
          <OpinionsComponent>
            <SingleSide>
              <SingleOpinion>
                <PersonBox>
                  <img src={mariuszImage} alt="użytkownik" />
                  <h5>{client1}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client1_text}</p>
                </pre>
              </SingleOpinion>
              <SingleOpinion>
                <PersonBox>
                  <img src={danielImage} alt="użytkownik" />
                  <h5>{client4}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client4_text}</p>
                </pre>
              </SingleOpinion>
            </SingleSide>

            <SingleSide>
              <SingleOpinion>
                <PersonBox>
                  <img src={patrycjaImage} alt="użytkownik" />
                  <h5>{client2}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client2_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={beataImage} alt="użytkownik" />
                  <h5>{client3}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client3_text}</p>
                </pre>
              </SingleOpinion>
              <SingleOpinion>
                <PersonBox>
                  <img src={emiliaImage} alt="użytkownik" />
                  <h5>{client5}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client5_text}</p>
                </pre>
              </SingleOpinion>
            </SingleSide>
          </OpinionsComponent>
        </Wrapper>
      </Main>
    )
  }

  if (isPhone) {
    return (
      <Main>
        <img src={lion} alt="lew" />
        <Wrapper>
          <h3>{happy_clients}</h3>
          <OpinionsComponent>
            <SingleSide>
              <SingleOpinion>
                <PersonBox>
                  <img src={mariuszImage} alt="użytkownik" />
                  <h5>{client1}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client1_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={danielImage} alt="użytkownik" />
                  <h5>{client4}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client4_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={patrycjaImage} alt="użytkownik" />
                  <h5>{client2}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client2_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={beataImage} alt="użytkownik" />
                  <h5>{client3}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client3_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={emiliaImage} alt="użytkownik" />
                  <h5>{client5}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client5_text}</p>
                </pre>
              </SingleOpinion>
            </SingleSide>
          </OpinionsComponent>
        </Wrapper>
      </Main>
    )
  }
  if (!isTablet & !isPhone) {
    return (
      <Main>
        <img src={lion} alt="lew" />
        <Wrapper>
          <h3>{happy_clients}</h3>
          <OpinionsComponent>
            <SingleSide>
              <SingleOpinion>
                <PersonBox>
                  <img src={mariuszImage} alt="użytkownik" />
                  <h5>{client1}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client1_text}</p>
                </pre>
              </SingleOpinion>
            </SingleSide>

            <SingleSide>
              <SingleOpinion>
                <PersonBox>
                  <img src={patrycjaImage} alt="użytkownik" />
                  <h5>{client2}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client2_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={beataImage} alt="użytkownik" />
                  <h5>{client3}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client3_text}</p>
                </pre>
              </SingleOpinion>
            </SingleSide>

            <SingleSide>
              <SingleOpinion>
                <PersonBox>
                  <img src={danielImage} alt="użytkownik" />
                  <h5>{client4}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client4_text}</p>
                </pre>
              </SingleOpinion>

              <SingleOpinion>
                <PersonBox>
                  <img src={emiliaImage} alt="użytkownik" />
                  <h5>{client5}</h5>
                </PersonBox>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  <p>{client5_text}</p>
                </pre>
              </SingleOpinion>
            </SingleSide>
          </OpinionsComponent>
        </Wrapper>
      </Main>
    )
  }
}

export default ThirdSection
